import { FC } from 'react';

import { StyledContainer, StyledLine } from '~/components/atoms/block-title/styled';
import { Text } from '~/components/ui/text';
import { COLORS } from '~/styles/colors';

interface BlockTitleProps {
  text: string;
  hideRight?: boolean;
  className?: string;
}

export const BlockTitle: FC<BlockTitleProps> = ({ text, hideRight = false, className }) => (
  <StyledContainer className={className}>
    <StyledLine />
    <Text sx={{ color: COLORS.primary }} variant="subheader">
      {text}
    </Text>
    {!hideRight && <StyledLine />}
  </StyledContainer>
);
